//发表运动打卡
const postHealthUrl = `/gateway/hc-health/miniapi/healthRecord/add`;
//我的运动打卡
const myHealthUrl = `/gateway/hc-health/miniapi/healthRecord/mineList`;
//运动打卡详情
const healthDetailUrl = `/gateway/hc-health/miniapi/healthRecord/detailInfo`;
//社区共建墙
const wishWallUrl = `/gateway/hc-govern/miniapi/communityConstruction/list`;
// 微信运动步数展示接口
const weChatMovementUrl = `/gateway/hc-health/miniapi/healthRecord/weChatMovement`;
// 领取微信运动积分接口
const weChatMovementPointUrl = `/gateway/hc-health/miniapi/healthRecord/weChatMovementPoint`;
// 是否显示”健身房二维码“按钮
const showGymQrcodeButton = `/gateway/hc-serve/miniapi/gymuserqrcode/showGymQrcodeButton`;
// 获取二维码code
const getGymQrcode = `/gateway/hc-serve/miniapi/gymuserqrcode/getGymQrcode`;

export {
  postHealthUrl,
  myHealthUrl,
  healthDetailUrl,
  wishWallUrl,
  weChatMovementUrl,
  weChatMovementPointUrl,
  showGymQrcodeButton,
  getGymQrcode,
};
